import availableTrialsAdapter from 'self-service-api/adapters/availableTrialsAdapter';
import { TrialsApi } from 'self-service-api/core/api/trialApi';
export const getAvailableTrials = () => {
  return TrialsApi.getAvailableTrials().then(availableTrials => {
    return availableTrialsAdapter(availableTrials);
  });
};